import { LegalClientBusinessRelationshipParam } from 'api/types/params';

import { CompanyBusinessRelationshipFormType } from '../../forms/companyBusinessRelationshipForm';

export const getBusinessRelationshipParam = (
  values: CompanyBusinessRelationshipFormType
): LegalClientBusinessRelationshipParam => ({
  businessRelationshipGoals:
    values.businessRelationship.businessRelationshipGoals.map(
      ({ value }) => value
    ),
  businessRelationshipNatures:
    values.businessRelationship.businessRelationshipNatures.map(
      ({ value }) => value
    ),
  otherBusinessRelationshipGoal:
    values.businessRelationship.otherBusinessRelationshipGoal ?? null,
  otherBusinessRelationshipNature:
    values.businessRelationship.otherBusinessRelationshipNature ?? null,
  otherPlannedOperationType:
    values.businessRelationship.otherPlannedOperationType ?? null,
  plannedAssetSize: values.businessRelationship.plannedAssetSize,
  plannedAssetTypes: values.businessRelationship.plannedAssetTypes.map(
    ({ value }) => value
  ),
  plannedOperationTypes: values.businessRelationship.plannedOperationTypes.map(
    ({ value }) => value
  ),
});
